import { render, staticRenderFns } from "./DealerOverview.vue?vue&type=template&id=71cdf446&"
import script from "./DealerOverview.vue?vue&type=script&lang=js&"
export * from "./DealerOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports